export default {}
export const Permissions = {
    Impersonate: 0,
}